import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import './ProjectsItem.css';
import { Link } from 'react-router-dom';

export default function ProjectsItem({projectItem, projectPreferences, user, services, isMobile, getClients, toggleNotifications}) {
    const maxURLLength = 25

    const handleDropdownClick = (evt) => {
        evt.stopPropagation()
    }

  return (
    <tr className='ProjectsItem'>
        { !projectPreferences.includes('projNum') &&
        <td className='projNum'>
            {projectItem.projNum? projectItem.projNum:'---'}
        </td>
        }
        { !projectPreferences.includes('projType') &&
        <td className='projType'>
            {projectItem.projType? capitalizeFirstLetter(projectItem.projType):'---'}
        </td>
        }
        { !projectPreferences.includes('projTitle') &&
        <td className='projTitle'>
            {projectItem.projTitle? capitalizeFirstLetter(projectItem.projTitle) : 
            services.find((service) =>service.code===projectItem.projType) ?`${services.find((service) =>service.code===projectItem.projType).name} for ${capitalizeFirstLetter(projectItem.clientName)}`: 
            `${projectItem.projType} for ${capitalizeFirstLetter(projectItem.clientName)}`}
        </td>
        }
        { !projectPreferences.includes('clientNumber') &&
        <td className='clientNumber'>
            {projectItem.clientNumber? projectItem.clientNumber:'---'}
        </td>
        }
        { !projectPreferences.includes('clientName') &&
        <td className='clientName'>
            { (['admin', 'manager'].includes(user.userType) && projectItem.clientID) ?
            <Link to={`/clients/${projectItem.clientID}`}>
                {projectItem.clientName? capitalizeFirstLetter(projectItem.clientName):'---'}
            </Link>
            :
            <div>
                {projectItem.clientName? capitalizeFirstLetter(projectItem.clientName):'---'}
            </div>
            }
        </td>
        }
        { !projectPreferences.includes('submissionDate') &&
        <td className='submissionDate'>
            <div>
                { projectItem.submissionDate ?
                new Date(projectItem.submissionDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
                :
                '---'
                }
            </div>
        </td>
        }
        { !projectPreferences.includes('dueDate') &&
        <td className='dueDate'>
            <div>
                { projectItem.dueDate ?
                new Date(projectItem.dueDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
                : 
                '---'
                }
            </div>
        </td>
        }
        { !projectPreferences.includes('clientDeadline') &&
        <td className='clientDeadline'>
            <div>
                { projectItem.clientDeadline ?
                new Date(projectItem.clientDeadline).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })
                : 
                '---'
                }
            </div>
        </td>
        }
        { !projectPreferences.includes('managerName') &&
        <td className='managerName'>
            {projectItem.managerName? capitalizeFirstLetter(projectItem.managerName):'---'}
        </td>
        }
        { !projectPreferences.includes('assignedAnalystName') &&
        <td className='assignedAnalystName'>
            {projectItem.assignedAnalystName? capitalizeFirstLetter(projectItem.assignedAnalystName):'---'}
        </td>
        }
        { !projectPreferences.includes('ndaStatus') &&
        <td className='ndaStatus status'>
            <div className={`statusContainer ${projectItem.ndaStatus}`}>
                <div className={`statusColor ${projectItem.ndaStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.ndaStatus === 'complete' ? 'Complete' : projectItem.ndaStatus === 'incomplete' ? 'Incomplete' : 'N/A'}
                    </strong>
                </div>
            </div>
        </td>
        }
        { !projectPreferences.includes('contractStatus') &&
        <td className='contractStatus status'>
            <div className={`statusContainer ${projectItem.contractStatus}`}>
                <div className={`statusColor ${projectItem.contractStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.contractStatus === 'complete' ? 'Complete' : 'Incomplete'}
                    </strong>
                </div>
            </div>
        </td>
        }
        { !projectPreferences.includes('firstInvoiceStatus') &&
        <td className='firstInvoiceStatus status'>
            <div className={`statusContainer ${projectItem.firstInvoiceStatus}`}>
                <div className={`statusColor ${projectItem.firstInvoiceStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.firstInvoiceStatus === 'sent' ? 'Sent' : projectItem.firstInvoiceStatus === 'pending' ? 'Pending' : projectItem.firstInvoiceStatus === 'paid' ? 'Paid' : 'N/A'}
                    </strong>
                </div>
            </div>
        </td>
        }
        { !projectPreferences.includes('intakeFormStatus') &&
        <td className='intakeFormStatus status'>
            <div className={`statusContainer ${projectItem.intakeFormStatus}`}>
                <div className={`statusColor ${projectItem.intakeFormStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.intakeFormStatus === 'new' ? 'New' : projectItem.intakeFormStatus === 'inProgress' ? 'In Progress' : projectItem.intakeFormStatus === 'submitted' ? 'Submitted' : projectItem.intakeFormStatus === 'complete' ? 'Complete' : projectItem.intakeFormStatus === 'changesSubmitted' ? 'Changes Made' : projectItem.intakeFormStatus === 'changesApproved' ? 'Changes Approved' : projectItem.intakeFormStatus === 'changesRejected' ? 'Changes Rejected' : ''}
                    </strong>
                </div>
            </div>
        </td>
        }
        { !projectPreferences.includes('projectStatus') &&
        <td className='projectStatus status'>
            <div className={`statusContainer ${projectItem.projectStatus}`}>
                <div className={`statusColor ${projectItem.projectStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.projectStatus === 'unassigned' ? 'Unassigned' : projectItem.projectStatus === 'inProgress' ? 'In Progress' : projectItem.projectStatus === 'inReview' ? 'In Review' : projectItem.projectStatus === 'completed' ? 'Completed' : 'Cancelled'}
                    </strong>
                </div>
            </div>
        </td>
        }
        { !projectPreferences.includes('projectReportStatus') &&
        <td className='projectReportStatus status'>
            <div className={`statusContainer ${projectItem.projectReportStatus}`}>
                <div className={`statusColor ${projectItem.projectReportStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.projectReportStatus === 'pending' ? 'Pending' : projectItem.projectReportStatus === 'generated' ? 'Generated' : 'N/A'}
                    </strong>
                </div>
            </div>
        </td>
        }
        { !projectPreferences.includes('secondInvoiceStatus') &&
        <td className='secondInvoiceStatus status'>
            <div className={`statusContainer ${projectItem.secondInvoiceStatus}`}>
                <div className={`statusColor ${projectItem.secondInvoiceStatus}`}></div>
                <div className='statusText'>
                    <strong>
                        {projectItem.secondInvoiceStatus === 'sent' ? 'Sent' : projectItem.secondInvoiceStatus === 'pending' ? 'Pending' : projectItem.secondInvoiceStatus === 'paid' ? 'Paid' : 'N/A'}
                    </strong>
                </div>
            </div>
        </td>
        }
        { !projectPreferences.includes('ndaURL') &&
        <td className='ndaURL linkChain'>
            {projectItem.ndaURL? 
            <a href={projectItem.ndaURL.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        }
        { !projectPreferences.includes('contractURL') &&
        <td className='contractURL linkChain'>
            {projectItem.contractURL? 
            <a href={projectItem.contractURL.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        }
        { !projectPreferences.includes('firstInvoiceURL') &&
        <td className='firstInvoiceURL linkChain'>
            {projectItem.firstInvoiceURL? 
            <a href={projectItem.firstInvoiceURL.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        }
        { !projectPreferences.includes('formURL') &&
        <td className='formURL linkChain'>
            {projectItem.formURL? 
            <a href={projectItem.formURL.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        }
        { !projectPreferences.includes('projectReportURL') &&
        <td className='projectReportURL linkChain'>
            {projectItem.projectReportURL? 
            <a href={projectItem.projectReportURL.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        }
        { !projectPreferences.includes('secondInvoiceURL') &&
        <td className='secondInvoiceURL linkChain'>
            {projectItem.secondInvoiceURL? 
            <a href={projectItem.secondInvoiceURL.trim()} rel="noreferrer" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                    <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                    <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                </svg>
            </a>
            :
            '---'
            }
        </td>
        }
        { !projectPreferences.includes('otherURLs') &&
        <td className='otherURLs linkChain'>
            {(projectItem.otherURL1 || projectItem.otherURL2 || projectItem.otherURL3 || projectItem.otherURL4)?
            <div className='otherURLsContainer dropdown'>
                <div className='otherLinksDropDownToggle' data-title='otherLinks' id='otherLinksDropDownToggle' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" fill="currentColor" className="bi bi-link-45deg" viewBox="0 0 16 16">
                        <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                        <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
                    </svg>
                </div>
                <div className='dropdown-menu otherLinksDropDown' aria-labelledby="otherLinksDropDownToggle" onClick={handleDropdownClick}>
                    { projectItem.otherURL1 &&
                    <div className='otherURLsItem'>
                        <a target='_blank' rel="noreferrer" href={`${projectItem.otherURL1}`}>{`${projectItem.otherURL1.substring(0,maxURLLength)}${projectItem.otherURL1.length > maxURLLength ? '...' : ''}`}</a>
                    </div>
                    }
                    { projectItem.otherURL2 &&
                    <div className='otherURLsItem'>
                        <a target='_blank' rel="noreferrer" href={`${projectItem.otherURL2}`}>{`${projectItem.otherURL2.substring(0,maxURLLength)}${projectItem.otherURL2.length > maxURLLength ? '...' : ''}`}</a>
                    </div>
                    }
                    { projectItem.otherURL3 &&
                    <div className='otherURLsItem'>
                        <a target='_blank' rel="noreferrer" href={`${projectItem.otherURL3}`}>{`${projectItem.otherURL3.substring(0,maxURLLength)}${projectItem.otherURL3.length > maxURLLength ? '...' : ''}`}</a>
                    </div>
                    }
                    { projectItem.otherURL4 &&
                    <div className='otherURLsItem'>
                        <a target='_blank' rel="noreferrer" href={`${projectItem.otherURL4}`}>{`${projectItem.otherURL4.substring(0,maxURLLength)}${projectItem.otherURL4.length > maxURLLength ? '...' : ''}`}</a>
                    </div>
                    }
                </div>
            </div>
            :
            '---'
            }
        </td>
        }
        { !projectPreferences.includes('createdAt') &&
        <td className='createdAt'>
            <div>
                {new Date(projectItem.createdAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
        </td>
        }
        { !projectPreferences.includes('updatedAt') &&
        <td className='lastUpdate'>
            <div>
                {new Date(projectItem.updatedAt).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' })}
            </div>
        </td>
        }
        <td className='actions'>
            <div className='actionButtonContainer'>
                <button className='updateProject' title='Update Project' data-bs-toggle="modal" data-bs-target={`#updateProjectModal${projectItem._id}`}>
                    <svg width="32" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M25.3924 23.4533C25.8971 23.4533 26.3076 23.8692 26.3076 24.3805C26.3076 24.8927 25.8971 25.3076 25.3924 25.3076H20.2192C19.7144 25.3076 19.3039 24.8927 19.3039 24.3805C19.3039 23.8692 19.7144 23.4533 20.2192 23.4533H25.3924ZM21.8048 9.63334L23.1411 10.6949C23.6891 11.1234 24.0544 11.6883 24.1794 12.2824C24.3236 12.9358 24.1698 13.5776 23.7372 14.1328L15.7769 24.4269C15.4116 24.8944 14.8732 25.1573 14.2963 25.1671L11.1238 25.206C10.9507 25.206 10.8065 25.0892 10.7681 24.9236L10.047 21.7974C9.92204 21.2228 10.047 20.6287 10.4123 20.171L16.0557 12.8667C16.1518 12.7498 16.3249 12.7313 16.4402 12.818L18.8149 14.7074C18.9687 14.834 19.1802 14.9022 19.4013 14.8729C19.8724 14.8145 20.1896 14.386 20.1416 13.9282C20.1127 13.6945 19.9974 13.4997 19.8435 13.3536C19.7955 13.3147 17.5362 11.5032 17.5362 11.5032C17.392 11.3864 17.3632 11.1721 17.4785 11.027L18.3726 9.86707C19.1994 8.80552 20.6415 8.70813 21.8048 9.63334Z" fill="#1A5E9B"/>
                        <rect x="1" y="1" width="33" height="33" rx="7" stroke="#1A5E9B" strokeOpacity="0.24" strokeWidth="2"/>
                    </svg>
                </button>
            </div>
        </td>
    </tr>
  )
}
